<div class="transport-action-bar toolbar">
  <div class="group group-transport">
    <div class="buttons">
      <button mat-icon-button (click)="register()"
        [matTooltip]="'Register' | translate: ['tmc.visit.overview.action.register', translationService.language]">
        <mat-icon>
          <sc-icon iconClass="fa-plus"></sc-icon>
        </mat-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="registerTransportForVehicle()" [disabled]="registerTransportForVehicleDisabled"
        [matTooltip]="'Register' | translate: ['tmc.visit.overview.action.register-for-vehicle', translationService.language]">
        <mat-icon>
          <span class="fa-stack" style="position: inherit;">
            <sc-icon iconClass="fa-square fa-stack-1x" style="font-size:28px;"></sc-icon>
            <sc-icon iconClass="fa-plus fa-stack-1x" style="font-size:16px;"></sc-icon>
          </span>
        </mat-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="editRoute()" [disabled]="editRouteDisabled"
        [matTooltip]="'Edit Route' | translate: ['tmc.visit.overview.action.editRoute', translationService.language]">
        <sc-icon iconClass="fa-route"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="editTransport()" [disabled]="editTransportDisabled"
        [matTooltip]="'edit transport' | translate: ['tmc.visit.overview.action.editTransport', translationService.language]">
        <sc-icon iconClass="fa-edit"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="showTransportDetails()" [disabled]="showTransportDetailsDisabled"
        [matTooltip]="'Transport Details' | translate: ['tmc.visit.overview.action.showTransportDetails', translationService.language]">
        <sc-icon iconClass="fa-info"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="deleteTransport()" [disabled]="deleteTransportDisabled"
        [matTooltip]="'delete transport' | translate: ['tmc.visit.overview.action.cancelTransport', translationService.language]">
        <sc-icon iconClass="fa-times"></sc-icon>
      </button>
      <sc-content-spacer *ngIf="cps.isEnabled('feature.globalconnect', true)"></sc-content-spacer>
      <button mat-icon-button (click)="showGcCase()" [disabled]="showGcCaseDisabled"
        *ngIf="cps.isEnabled('feature.globalconnect', true)"
        [matTooltip]="'QC-Case' | translate: ['tmc.visit.overview.action.showGcCase', translationService.language]">
        <sc-icon iconClass="fa-mobile-android-alt"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="editTransportDisabled"
        [matTooltip]="'print Handout' | translate: ['tmc.visit.overview.action.printHandout', translationService.language]">
        <sc-icon iconClass="fa-print"></sc-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="printTransportSheet()">
          <sc-icon iconClass="fa-truck"></sc-icon>
          {{'print Access Handout' | translate: ['tmc.visit.overview.action.printAccessHandout',
          translationService.language]}}
        </button>
        <button mat-menu-item (click)="printCommunicationSheet()">
          <sc-icon iconClass="fa-qrcode"></sc-icon>
          {{'print CommunicationHandout' | translate: ['tmc.visit.overview.action.printCommunicationHandout',
          translationService.language]}}
        </button>
      </mat-menu>
    </div>
    <div class="title">{{'transport' | translate: ['tmc.visit.overview.action-group.transport',
      translationService.language]}}</div>
  </div>
  <div class="group group-transport">

    <div class="buttons">
      <!-- <button mat-icon-button class="double-icon" (click)="registerEntrance()" [disabled]="registerEntranceDisabled"
        [matTooltip]="'edit issues' | translate: ['tmc.visit.overview.action.registerEntrance', translationService.language]">
        <sc-icon iconClass="fa-industry" class="factory"></sc-icon>
        <sc-icon iconClass="fa-truck fa-flip-horizontal" class="truck"></sc-icon>
      </button> -->
      <!-- <sc-content-spacer></sc-content-spacer> -->
      <button mat-icon-button class="double-icon" (click)="registerEntranceNew()"
        [matTooltip]="'edit issues' | translate: ['tmc.visit.overview.action.registerEntrance', translationService.language]">
        <sc-icon iconClass="fa-industry" class="factory"></sc-icon>
        <sc-icon iconClass="fa-truck fa-flip-horizontal" class="truck"></sc-icon>
      </button>
      <!-- <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button class="double-icon" (click)="registerLeave()" [disabled]="registerLeaveDisabled"
        [matTooltip]="'Register Leave' | translate: ['tmc.visit.overview.action.registerLeave', translationService.language]">
        <sc-icon iconClass="fa-industry " class="factory"></sc-icon><sc-icon iconClass="fa-truck " class="truck"></sc-icon>
      </button> -->
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button class="double-icon" (click)="registerLeaveNew()" [disabled]="registerLeaveDisabled"
        [matTooltip]="'Register Leave' | translate: ['tmc.visit.overview.action.registerLeave', translationService.language]">
        <sc-icon iconClass="fa-industry " class="factory"></sc-icon><sc-icon iconClass="fa-truck " class="truck"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="pauseTransport()" [disabled]="pauseTransportDisabled"
        [matTooltip]="'pause transport' | translate: ['tmc.visit.overview.action.pauseTransport', translationService.language]"
        *ngIf="cps.isEnabled('clientproperty.visitors.feature_enablement.pause', false)">
        <sc-icon iconClass="fa-stopwatch"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="attachDetachTransport()" [disabled]="attachDetachTransportDisabled"
        [matTooltip]="'split / merge' | translate: ['tmc.visit.overview.action.attachDetach', translationService.language]"
        *ngIf="cps.isEnabled(clientParameters.P_VISITS_ATTACH_DETACH_ENABLED, false)">
        <sc-icon iconClass="fa-code-merge"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <app-link-transport-dialog-action [transportId]="transport?.id" [disabled]="linkTransportsDisabled"
        (onChange)="handleChange()">
      </app-link-transport-dialog-action>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="performTransportUmbrueckung()" [disabled]="umbrueckungDisabled"
        *ngIf="cps.isEnabled(clientParameters.FEATURES_UMBRUECKUNG, false)"
        [matTooltip]="'swap trailer' | translate: ['tmc.visit.overview.action.transportUmbrueckung', translationService.language]">
        <sc-icon iconClass="fa-random"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="sendMessage()" [disabled]="sendMessageDisabled"
        [matTooltip]="'send message' | translate: ['tmc.visit.overview.action.sendMessage', translationService.language]">
        <sc-icon iconClass="fa-envelope"></sc-icon>
      </button>
      <sc-content-spacer *ngIf="scanNumberplateEnabled"></sc-content-spacer>
      <button mat-icon-button (click)="scanNumberplate()" *ngIf="scanNumberplateEnabled"
        [matTooltip]="'scan numberplate' | translate: ['tmc.visit.overview.action.scanNumberplate', translationService.language]">
        <sc-icon iconClass="fa-camera-cctv"></sc-icon>
      </button>
    </div>
    <div class="title">{{'control' | translate: ['tmc.visit.overview.action-group.control',
      translationService.language]}}</div>
  </div>
  <div class="group group-transport">

    <div class="buttons">
      <button mat-icon-button (click)="handoutSupplementaryEquipment()"
        [disabled]="handoutSupplementaryEquipmentDisabled"
        [matTooltip]="'Handout Supplementary Equipment' | translate: ['tmc.visit.overview.action.handoutSupplementaryEquipment', translationService.language]">
        <sc-icon iconClass="fa-upload"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="takeBackSupplementaryEquipment()"
        [disabled]="takeBackSupplementaryEquipmentDisabled"
        [matTooltip]="'Take back Supplementary Equipment' | translate: ['tmc.visit.overview.action.takeBackSupplementaryEquipment', translationService.language]">
        <sc-icon iconClass="fa-download"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="editIssues()" [disabled]="editIssuesDisabled"
        [matTooltip]="'edit issues' | translate: ['tmc.visit.overview.action.editIssues', translationService.language]"
        *ngIf="cps.isEnabled(this.clientParameters.FEATURES_ISSUES, false)">
        <sc-icon iconClass="fa-exclamation-triangle"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="weighTransport()" [disabled]="weighTransportDisabled"
        [matTooltip]="'Weigh Transport' | translate: ['tmc.visit.overview.action.weighTransport', translationService.language]"
        *ngIf="cps.isEnabled(clientParameters.P_VISITS_WEIGHING_ENABLED, false)">
        <sc-icon iconClass="fa-balance-scale"></sc-icon>
      </button>
    </div>
    <div class="title">{{'documentation' | translate: ['tmc.visit.overview.action-group.documentation',
      translationService.language]}}</div>
  </div>
  <div class="group group-ungrouped">

    <div class="buttons">
      <button mat-icon-button (click)="emergencyCall()" [disabled]="emergencyCallDisabled"
        [matTooltip]="'emergency call' | translate: ['tmc.visit.overview.action.emergencyCall', translationService.language]">
        <sc-icon iconClass="fa-siren-on"></sc-icon>
      </button>
      <sc-content-spacer *ngIf="simulatorEnabled"></sc-content-spacer>
      <button mat-icon-button (click)="toggleSimulation()" *ngIf="!simulatorStarted && simulatorEnabled"
        [matTooltip]="'Start Simulator' | translate: ['tmc.visit.overview.action.simulator.start', translationService.language]">
        <sc-icon iconClass="fa-play"></sc-icon>
      </button>
      <button mat-icon-button (click)="toggleSimulation()" *ngIf="simulatorStarted && simulatorEnabled"
        [matTooltip]="'Stop Simulator' | translate: ['tmc.visit.overview.action.simulator.stop', translationService.language]">
        <sc-icon iconClass="fa-stop"></sc-icon>
      </button>
      <sc-content-spacer *ngIf="cleanTransportFeatureAvailable"></sc-content-spacer>
      <button mat-icon-button (click)="cleanTransport()" *ngIf="cleanTransportFeatureAvailable"
        [disabled]="cleanTransportDisabled"
        [matTooltip]="'Cleanup Transport' | translate: ['tmc.visit.overview.action.clean-transport', translationService.language]">
        <sc-icon iconClass="fa-broom"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="activateTransports()"
        [matTooltip]="'activate' | translate: ['tmc.visit.overview.action.activate', translationService.language]">
        <sc-icon iconClass="fa-search-plus"></sc-icon>
      </button>
    </div>
    <div class="title">{{'others' | translate: ['tmc.visit.overview.action-group.others',
      translationService.language]}}</div>
  </div>
</div>
